import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

// Components
import Work from './work/Work'
import News from './news/News'
import Page from './page/Page'
import Review from './review/Review'
import Exhibition from './exhibition/Exhibition'

// JS
import { MOBILEDEVICEWIDTH } from './../../utils/constants'

// CSS
import './Main.css'

class Main extends Component {

    static propTypes = {
        projects: PropTypes.array.isRequired,
        categories: PropTypes.array.isRequired,
        selectedCategory: PropTypes.string,
        onSelectCategory: PropTypes.func.isRequired,
        news: PropTypes.array.isRequired,
        reviews: PropTypes.array.isRequired,
        exhibitions: PropTypes.array.isRequired
    }

    render() {
        return (
            <main className="main">
                <MediaQuery maxDeviceWidth={MOBILEDEVICEWIDTH} className="main-mobile" />
                <Switch>
                    <Route exact path='/' render={()=><Work projects={this.props.projects} categories={this.props.categories} selectedCategory={this.props.selectedCategory} onSelectCategory={this.props.onSelectCategory} />} />
                    <Route path='/work' render={()=><Work projects={this.props.projects} categories={this.props.categories} selectedCategory={this.props.selectedCategory} onSelectCategory={this.props.onSelectCategory} />} />
                    <Route path='/news' render={()=><News news={this.props.news} />} />
                    <Route path='/page/:string' render={(props)=> <Page {...props} exhibitions={this.props.exhibitions} news={this.props.news} />} />
                    <Route path='/reviews' render={()=><Review reviews={this.props.reviews} />} />
                    <Route path='/exhibitions' render={()=><Exhibition exhibitions={this.props.exhibitions} />} />
                </Switch>
            </main>
        )
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main/Main.js